var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithubLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6808_12165)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 4.16797C7.58199 4.16797 4 7.76366 4 12.2002C4 15.7482 6.292 18.7586 9.4715 19.8208C9.8715 19.8946 10.0175 19.6466 10.0175 19.4337C10.0175 19.243 10.0105 18.738 10.0065 18.0679C7.78099 18.5533 7.3115 16.9911 7.3115 16.9911C6.948 16.0634 6.4235 15.8165 6.4235 15.8165C5.697 15.318 6.4785 15.328 6.4785 15.328C7.281 15.3847 7.70349 16.1558 7.70349 16.1558C8.41749 17.3831 9.576 17.0288 10.032 16.8229C10.1045 16.3039 10.3115 15.95 10.54 15.7492C8.7635 15.5464 6.896 14.8577 6.896 11.78C6.896 10.9031 7.2075 10.1862 7.7195 9.62451C7.637 9.42121 7.36251 8.60499 7.79751 7.49913C7.79751 7.49913 8.4695 7.28326 9.9975 8.32237C10.636 8.14416 11.32 8.05531 12.0005 8.0518C12.68 8.05531 13.3645 8.14416 14.0035 8.32237C15.5305 7.28326 16.201 7.49913 16.201 7.49913C16.6375 8.60499 16.363 9.42121 16.2805 9.62451C16.7935 10.1862 17.103 10.9031 17.103 11.78C17.103 14.8652 15.2325 15.5444 13.4505 15.7432C13.7375 15.9911 13.9935 16.4811 13.9935 17.2306C13.9935 18.3043 13.9835 19.1702 13.9835 19.4337C13.9835 19.6486 14.1275 19.8986 14.5335 19.8198C17.71 18.7556 20 15.7472 20 12.2002C20 7.76366 16.418 4.16797 11.9995 4.16797Z",
    fill: "#EA7E68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6808_12165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/github-logo.8ace7034b641a59baae0e31314c5fede.svg";
export { ForwardRef as ReactComponent };